import { InfoOutlined } from '@mui/icons-material';
import { Box, FormHelperText } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JoveFormErrorInfoView = function JoveFormErrorInfoView(props) {
  var error = props.error,
      errMessage = props.errMessage;
  return !!error ? /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-row items-center space-x-1",
    children: [/*#__PURE__*/_jsx(InfoOutlined, {
      className: "h-3 w-3 text-[#d32f2f]"
    }), /*#__PURE__*/_jsx(FormHelperText, {
      className: "react-hook-form-error",
      error: !!error,
      children: errMessage
    })]
  }) : null;
};